import _ from 'lodash';
import React from 'react';

import Button from 'components/Button';
import {
  default as DateRangeFilter,
  TopRightFixedCustomOverlay
} from 'components/Filters/DateRangeFilter';
import CustomerFilter from 'components/Filters/CustomerFilter';
import ToggleSelectFilter from 'components/Filters/ToggleSelectFilter';
import CreatedByAdminOrTeamFilter from 'components/Filters/CreatedByAdminOrTeamFilter';

// TODO: Move sdk/reporting to sdk/payments and reuse sdkFetchCustomerOptions
import {
  fetchCustomerOptions as sdkFetchCustomerOptions,
  fetchAdminOptions as sdkFetchAdminAndTeamOptions
} from 'sdk/reporting';

import './styles.css';

import {
  BEFORE_CUT_OFF_DATE_KEY_FOR_API,
  CREDIT_NOTE_STATUSES,
  XERO_STATUSES
} from 'ducks/reporting';

// TODO: Add an api for credit note statuses
const creditNoteStatusesData = [
  {label: 'Upcoming', value: CREDIT_NOTE_STATUSES.UPCOMING},
  {label: 'Paid', value: CREDIT_NOTE_STATUSES.PAID},
  {label: 'Void', value: CREDIT_NOTE_STATUSES.VOID},
  {
    label: 'Partially paid',
    value: CREDIT_NOTE_STATUSES.PARTIALLY_PAID
  }
];

const xeroStatusesData = [
  {label: 'Synced', value: XERO_STATUSES.SYNCED},
  {label: 'Failed', value: XERO_STATUSES.FAILED},
  {label: 'Before cut off date', value: BEFORE_CUT_OFF_DATE_KEY_FOR_API}
];

interface PassedProps {
  locationRef: string;
  setFilter: (field: string, value: any) => void;
  clearFilters: () => void;
  getFilters: any;
  scheduleTypesFilters: any;
}

class CreditNotesListFilters extends React.Component<PassedProps> {
  customerSelectElement: any = null;
  createdBySelectElement: any = null;

  fetchAdminAndTeamOptions = search => {
    const {locationRef} = this.props;

    return sdkFetchAdminAndTeamOptions({locationRef, search});
  };

  fetchCustomerOptions = search => {
    const {locationRef} = this.props;

    return sdkFetchCustomerOptions({locationRef, search});
  };

  onChangeCreatedBy = selectedOption => {
    const {setFilter} = this.props;

    if (_.isNull(selectedOption)) {
      setFilter('createdByTeam', null);
      setFilter('createdBy', null);
    } else if (selectedOption.object.isTeam) {
      setFilter('createdByTeam', selectedOption.value);
      setFilter('createdBy', null);
    } else {
      setFilter('createdBy', selectedOption.value);
      setFilter('createdByTeam', null);
    }
  };

  clearFilters = () => {
    if (_.get(this.customerSelectElement, 'state.selectedOption')) {
      this.customerSelectElement.clearSelectedOption();
    }

    if (_.get(this.createdBySelectElement, 'state.selectedOption')) {
      this.createdBySelectElement.clearSelectedOption();
    }

    this.props.clearFilters();
  };

  render() {
    const {setFilter, scheduleTypesFilters} = this.props;
    const filters: any = this.props.getFilters();

    return (
      <div className="PaymentsListFilters colab-row-space-between">
        <div className="colab-sidepadding-2">
          <ToggleSelectFilter
            label="Schedule"
            classNameForTesting="schedule"
            data={scheduleTypesFilters}
            value={filters.scheduleTypes}
            onChange={scheduleTypes =>
              setFilter('scheduleTypes', scheduleTypes)
            }
          />
          <ToggleSelectFilter
            label="Credit Note Status"
            classNameForTesting="creditNoteStatus"
            value={filters.statuses}
            data={creditNoteStatusesData}
            onChange={statuses => setFilter('statuses', statuses)}
          />
          <ToggleSelectFilter
            label="Xero Sync Status"
            classNameForTesting="xeroSyncStatus"
            value={filters.xeroStatuses}
            data={xeroStatusesData}
            onChange={xeroStatuses => setFilter('xeroStatuses', xeroStatuses)}
          />
          <CustomerFilter
            customerRef={el => (this.customerSelectElement = el)}
            fetchFunction={this.fetchCustomerOptions}
            clearOption={() => setFilter('customer', null)}
            onChange={customer => setFilter('customer', customer)}
          />
          <DateRangeFilter
            label="Issue date"
            fieldName="dateIssued"
            classNameForTesting="issueDate"
            start={filters.dateIssuedStart}
            end={filters.dateIssuedEnd}
            overlayComponent={TopRightFixedCustomOverlay}
            onChange={(dateField, date) => setFilter(dateField, date)}
          />
          <DateRangeFilter
            label="Rent Start Date"
            fieldName="rentStartDate"
            classNameForTesting="rentStartDate"
            start={filters.rentStartDateStart}
            end={filters.rentStartDateEnd}
            overlayComponent={TopRightFixedCustomOverlay}
            onChange={(dateField, date) => setFilter(dateField, date)}
          />
          <DateRangeFilter
            label="Rent End Date"
            fieldName="rentEndDate"
            classNameForTesting="rentEndDate"
            start={filters.rentEndDateStart}
            end={filters.rentEndDateEnd}
            overlayComponent={TopRightFixedCustomOverlay}
            onChange={(dateField, date) => setFilter(dateField, date)}
          />
          <DateRangeFilter
            label="Date created"
            fieldName="createdAt"
            classNameForTesting="createdAt"
            start={filters.createdAtStart}
            end={filters.createdAtEnd}
            overlayComponent={TopRightFixedCustomOverlay}
            onChange={(dateField, date) => setFilter(dateField, date)}
          />
          <CreatedByAdminOrTeamFilter
            createdByRef={el => (this.createdBySelectElement = el)}
            fetchFunction={this.fetchAdminAndTeamOptions}
            clearOption={() => setFilter('createdBy', null)}
            onChange={this.onChangeCreatedBy}
          />
        </div>
        <div>
          <Button clear onClick={this.clearFilters}>
            Clear all filters
          </Button>
        </div>
      </div>
    );
  }
}

export default CreditNotesListFilters;
